/*
export default `{
  "api_key": "YOUR_API_KEY", // Your API key you generated from the dashboard goes here
  "url": "https://httpbin.org/ip", // The site you want to scrape and parse
}`
*/
export default [
  {
    lang: 'json',
    format: 'json',
    code: `{
  "api_key": "YOUR_API_KEY", // Your API key you generated from the dashboard goes here
  "url": "https://httpbin.org/ip" // The site you want to scrape and parse
}`
  },
  {
    lang: 'curl',
    format: 'curl',
    code: `curl \\
  -d '{"api_key": "YOUR_API_KEY", "url": "https://httpbin.org/ip"}' \\
  -X POST https://api.scrapeowl.com/v1/scrape`
  },
  {
    lang: 'node',
    format: 'javascript',
    code: `const got = require('got');
 
(async () => {
  const {body} = await got.post("https://api.scrapeowl.com/v1/scrape", {
    json: {
      api_key: "YOUR_API_KEY",
      url: "https://httpbin.org/ip"
    },
    responseType: "json"
  });
  
  console.log(JSON.stringify(body.data));
})();`
  },
  {
    lang: 'php',
    format: 'php',
    code: `<?php
  $ch = curl_init( "https://api.scrapeowl.com/v1/scrape" );

  // Setup request to send json via POST.
  $array_of_data = array(
    "api_key" => "YOUR_API_KEY",
    "url" => "https://httpbin.org/ip"
  );

  $payload = json_encode( $array_of_data );

  curl_setopt( $ch, CURLOPT_POSTFIELDS, $payload );

  // Return response instead of printing.
  curl_setopt( $ch, CURLOPT_RETURNTRANSFER, true );

  // Send request.
  $result = curl_exec($ch);

  curl_close($ch);

  // Print response.
  echo $result;
?>`
  },
  {
    lang: 'python',
    format: 'python',
    code: `import requests
import json

#API details
scrapeowl_url = "https://api.scrapeowl.com/v1/scrape"

#Object of the request
object_of_data = {
  "api_key": "YOUR_API_KEY",
  "url": "https://example.com"
}

#Convert object to JSON
data = json.dumps(object_of_data)

#Making http post request
response = requests.post(scrapeowl_url, data)

#Print the JSON response from API
print(response.json())`
  },
  {
    lang: 'ruby',
    format: 'ruby',
    code: `require 'net/http'
require 'uri'
require 'json'

#API details
scrapeowl_uri = URI.parse("https://api.scrapeowl.com/v1/scrape")

#Object of the request
object_of_data = {
  api_key: "YOUR_API_KEY",
  url: "https://httpbin.org/ip"
}

#Create the HTTP objects
http = Net::HTTP.new(scrapeowl_uri.host, scrapeowl_uri.port)
request = Net::HTTP::Post.new(scrapeowl_uri.request_uri)
request.body = object_of_data.to_json

#Making http post request
response = http.request(request)

#Print the JSON response from API
puts JSON.parse(response.body)`
  }
]